<template>
  <div class="block-form">
    <q-input
      outlined
      type="textarea"
      :model-value="block.markdown"
      label="Texto"
      rows="4"
      hint="Soporta **negrita**, _itálica_, `código`"
      @update:model-value="emit('update', { ...block, markdown: $event })"
    />
  </div>
</template>

<script setup lang="ts">
interface ParagraphBlock {
  type: 'paragraph';
  markdown: string;
}

const props = defineProps<{ block: ParagraphBlock }>();
const emit = defineEmits<{ (e: 'update', block: ParagraphBlock): void }>();

void props;
</script>

<style scoped lang="scss">
.block-form {
  padding: 16px;
}
</style>
